import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';

var TabContent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TabContent, _React$Component);

  function TabContent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        hasIframe = _this$props.hasIframe,
        children = _this$props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: "tab-content" + (hasIframe ? ' iframe' : '')
    }, children);
  };

  return TabContent;
}(React.Component);

export default TabContent;